import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Enable mention debugging in development
if (import.meta.env.DEV) {
  (window as any).__DEBUG_MENTIONS__ = true;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);